import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=12d8a43c&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=12d8a43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8a43c",
  null
  
)

export default component.exports